// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '1cc917cb-cc26-48a8-95d2-a712c80924b6',
      type: 'Container',
      runtimeType: null,
      name: '',
      className: '',
      x: 14,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '924f59c9-1d99-4fd7-a25c-ad41db6eab4c',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 35,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.657895,
        y: 0.62963
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'GoalPreview_Task_Background',
      parent: '1cc917cb-cc26-48a8-95d2-a712c80924b6',
      data: undefined,
      stateByName: {}
    },
    {
      id: '1cde354e-8d5b-464a-bc63-a87f193476ae',
      type: 'Sprite',
      runtimeType: null,
      name: 'icon',
      className: '',
      x: 29,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.55
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.6,
        y: 1.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Small_Plank_Icon',
      parent: '1cc917cb-cc26-48a8-95d2-a712c80924b6',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'b13899a6-916f-4af8-ada6-453e3f3d32d7',
      type: 'Text',
      runtimeType: null,
      name: 'countText',
      className: '',
      x: 94,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '100',
      localize: false,
      maxWidth: 60,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '0x0044ff',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '1cc917cb-cc26-48a8-95d2-a712c80924b6',
      data: {
        template: '#'
      },
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class GoalPreviewTaskLayout {
  static raw = raw;
  root: Container;
  icon: Sprite;
  countText: Text & { data: typeof raw['list'][4]['data'] };

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      icon: typeof raw['list'][3];
      countText: typeof raw['list'][4];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
